import { Trans } from 'react-i18next';

import { Translate } from '@dreryk/react-common';
import { Heading, StyledFlex } from '@dreryk/react-components';
import { isDemo } from '@dreryk/demo-variant-frontend';

import { protectFeature } from '~libs.shared.system';
import { AdamedExpertAuthenticateOrRedirectButton } from '~libs.desktop.adamed-expert';

import { dashboardTranslationKeys } from '../translations';

import { BannerCard } from './advertisement/BannerCard';
import { ConfirmedAppointmentsCard } from './cards/confirmedAppointments/ConfirmedAppointmentsCard';
import { GifDecisionsCard } from './cards/GifDecisionsCard';
import { NewsCard } from './cards/NewsCard';
import { RegisteredAppointmentsCard } from './cards/registeredAppointments/RegisteredAppointmentsCard';
import { DashboardLoader } from './Dashboard.loader';
import { StyledDashboardGridBottomRow, StyledDashboardGridRow } from './Dashboard.styled';
import { DashboardModuleConfiguration } from './moduleConfiguration/DashboardModuleConfiguration';
import { EducationalMaterialsLoader } from './knowledge/EducationalMaterials.loader';
import { EducationalMaterials } from './knowledge/EducationalMaterials';

export const Dashboard = (): JSX.Element => {
   return (
      <DashboardLoader>
         {({ dashboardModuleConfiguration, practitionerDetails }) => (
            <>
               <StyledFlex justifyContent='space-between' gap={8}>
                  <Heading
                     testId={'heading'}
                     type='h2'
                     bold
                     content={
                        <Trans
                           i18nKey={dashboardTranslationKeys.welcomeHeader}
                           values={{
                              title: practitionerDetails.title,
                              name: practitionerDetails.firstName.asString(),
                              surname: practitionerDetails.lastName.asString(),
                           }}
                        />
                     }
                  />
                  <StyledFlex gap={8}>
                     {isDemo() ? null : protectFeature(['adamedExpert'], <AdamedExpertAuthenticateOrRedirectButton />)}
                     <DashboardModuleConfiguration dashboardModuleConfiguration={dashboardModuleConfiguration} />
                  </StyledFlex>
               </StyledFlex>
               <StyledFlex direction='column' gap={12}>
                  <Translate>{dashboardTranslationKeys.yourVisitsForToday}</Translate>
                  <StyledDashboardGridRow>
                     <RegisteredAppointmentsCard />
                     <ConfirmedAppointmentsCard />
                     <GifDecisionsCard />
                     <BannerCard location='DASHBOARD_TOP' />
                  </StyledDashboardGridRow>
                  <StyledFlex gap={12}>
                     <NewsCard />
                  </StyledFlex>
                  <StyledDashboardGridBottomRow>
                     <BannerCard location='DASHBOARD_BOTTOM' size={'BIG'} />
                     <EducationalMaterialsLoader>
                        {({ educationalMaterials }) => (
                           <EducationalMaterials educationalMaterials={educationalMaterials} />
                        )}
                     </EducationalMaterialsLoader>
                  </StyledDashboardGridBottomRow>
               </StyledFlex>
            </>
         )}
      </DashboardLoader>
   );
};
